var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 0.333344H1.28275C0.758939 0.333344 0.333344 0.764891 0.333344 1.29465V12.7054C0.333344 13.2351 0.758939 13.6667 1.28275 13.6667H12.7143C13.2381 13.6667 13.6667 13.2351 13.6667 12.7054V1.29465C13.6667 0.764891 13.2381 0.333344 12.7143 0.333344ZM4.36311 11.7619H2.38692V5.39882H4.36608V11.7619H4.36311ZM3.37501 4.52977C2.74108 4.52977 2.22918 4.01489 2.22918 3.38394C2.22918 2.75299 2.74108 2.23811 3.37501 2.23811C4.00596 2.23811 4.52084 2.75299 4.52084 3.38394C4.52084 4.01787 4.00894 4.52977 3.37501 4.52977V4.52977ZM11.7708 11.7619H9.79465V8.66668C9.79465 7.92858 9.77977 6.97918 8.76787 6.97918C7.73811 6.97918 7.58037 7.78275 7.58037 8.61311V11.7619H5.60418V5.39882H7.50001V6.26787H7.5268C7.79168 5.76787 8.43751 5.24108 9.39882 5.24108C11.3988 5.24108 11.7708 6.55953 11.7708 8.27382V11.7619V11.7619Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.19612fdb23c98848437a9163121397e7.svg";
export { ForwardRef as ReactComponent };